import { useEffect } from 'react'
import { useIsOnline } from '@hooks/useIsOnline'

import useTipsStore from '@store/useTipsStore'

export const useTipsQueue = (isSimulatedProgress = false) => {
  const isOnline = useIsOnline()

  const processQueue = useTipsStore(state => state.processQueue)
  const requestsQueue = useTipsStore(state => state.requestsQueue)

  useEffect(() => {
    if (isOnline && !isSimulatedProgress) {
      processQueue()
    }
  }, [processQueue, requestsQueue, isOnline, isSimulatedProgress])
}
